// src/plugins/idle-detection.js
import { activityStore } from '@/stores/activity'; // Update path accordingly

export default defineNuxtPlugin(() => {
    if (process.client) {
        const idleTimeout = 10 * 60 * 1000; // 10 minutes of inactivity
        const activity = activityStore();

        let timer: any;
        const resetTimer = async () => {
            if (timer) {
                activity.updateActivityStore(false); // Set inactivity to false
                clearTimeout(timer);
            }

            timer = setTimeout(() => {
                // activity.updateActivityStore(true); // Set inactivity to true after timeout
            }, idleTimeout);
        };
        const removeEventListeners = () => {
            document.removeEventListener('mousemove', resetTimer);
            document.removeEventListener('mousedown', resetTimer);
            document.removeEventListener('keydown', resetTimer);
        };

        // Attach event listeners
        document.addEventListener('mousemove', resetTimer);
        document.addEventListener('mousedown', resetTimer);
        document.addEventListener('keydown', resetTimer);

        // Cleanup when the window or document is unloaded
        window.addEventListener('beforeunload', removeEventListeners);

        // Initialize the timer when the app loads
        resetTimer();
    }
});
